import { NoLongerSelectableReason } from '@luminovo/api-contracts';
import { transEnum } from '@luminovo/frontend-utils';

import { noLongerSelectableReasonTranslations, solutionRemovalReasonTranslations } from '../i18n';

export function formatNoLongerSelectableReason(reason: NoLongerSelectableReason): string {
    if (reason.type === 'RemovedBySolutionFilters') {
        return transEnum(reason.data, solutionRemovalReasonTranslations);
    }
    return transEnum(reason.type, noLongerSelectableReasonTranslations);
}
